(() => {
  'use strict';
  const launch = () => window.BPLaunch;
  const getState = () => typeof launch()?.state === 'function' ? launch().state() : { active: false, now: Date.now() };
  const nowMs = state => typeof state.now === 'number' ? state.now : Date.now();
  const endMs = () => Date.parse(launch()?.config?.endAt || launch()?.endAt || '');
  const clockText = state => {
    const end = endMs();
    if (!Number.isFinite(end)) return '--:--:--';
    const left = Math.max(0, Math.ceil((end - nowMs(state)) / 1000));
    const hours = String(Math.floor(left / 3600)).padStart(2, '0');
    const minutes = String(Math.floor(left % 3600 / 60)).padStart(2, '0');
    const seconds = String(left % 60).padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
  };
  let lastActive;
  let lastHomepage;
  function render(state = getState(), force = false) {
    document.querySelectorAll('[data-bp-launch-countdown]').forEach(el => { el.textContent = clockText(state); });
    const homepage = document.body?.dataset.bpHomepage === 'true';
    if (!force && lastActive === state.active && lastHomepage === homepage) return;
    lastActive = state.active;
    lastHomepage = homepage;
    document.querySelectorAll('[data-bp-launch-only]').forEach(el => {
      el.hidden = !state.active || (el.hasAttribute('data-bp-launch-home') && !homepage);
    });
    document.querySelectorAll('[data-bp-launch-regular]').forEach(el => { el.hidden = !!state.active; });
    document.querySelectorAll('[data-bp-launch-quickpay]').forEach(el => { el.hidden = !!state.active; });
    document.documentElement.classList.toggle('bp-launch-window-active', !!state.active);
    document.querySelectorAll('[data-bp-launch-copy]').forEach(el => {
      const code = launch()?.config?.code || launch()?.code;
      if (code) el.firstChild.textContent = `${code} `;
    });
    document.querySelectorAll('[data-bp-launch-worlds-link]').forEach(el => {
      if (document.querySelector('#bp-launch-worlds')) return;
      const gateway = document.querySelector('[data-bp-home-gateway], #shopify-section-bp_home_mystery');
      if (gateway?.id) el.href = `#${gateway.id}`;
    });
  }
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-bp-launch-copy]');
    if (!button) return;
    const code = launch()?.config?.code || launch()?.code;
    if (!code) return;
    const status = button.parentElement.querySelector('[data-bp-launch-copy-status]');
    try {
      if (navigator.clipboard?.writeText) await navigator.clipboard.writeText(code);
      else throw new Error('Clipboard API non disponibile');
      if (status) status.textContent = 'Codice copiato';
    } catch {
      const input = document.createElement('input');
      input.value = code;
      input.setAttribute('readonly', '');
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.append(input);
      input.select();
      const copied = document.execCommand('copy');
      input.remove();
      button.focus();
      if (status) status.textContent = copied ? 'Codice copiato' : 'Seleziona il codice e copialo';
    }
  });
  document.addEventListener('shopify:section:load', () => render(getState(), true));
  document.addEventListener('bp:launch:tick', event => render(event.detail || getState()));
  document.addEventListener('DOMContentLoaded', () => render(getState(), true));
  Promise.resolve(launch()?.ready).then(() => {
    render(getState(), true);
  });
})();
